import React from "react"
import styled from 'styled-components'
import { useStaticQuery, graphql, Link } from "gatsby"


const LatestPostsSection = styled.div `
  margin-bottom: 3rem;
  margin-top: 1rem;
`

const BlogAsideSectionLabel = styled.div `
  font-family: Lato;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000000;
  letter-spacing: 1px;

  /* font-size: 1.5rem;
  font-weight: 300;
  text-transform: lowercase; */
`

const PostUnit = styled.div `
  margin-top: 2rem;
`

const PostUnitTitle = styled(Link) `
  font-family: Lato;
  font-weight: bold;
  text-decoration: none;
  font-size: 1.25rem;
  color: #C02907;

`

const PostUnitSubtitle = styled.p `
  margin-top: 0.5rem;
  font-family: 'Lato';
  font-size: 1.125em;
  margin-bottom: 0;
`


const LatestPostsAside = () => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}
          filter: { frontmatter: { type: { eq: "post" },  draft: { ne: true } } }, limit: 4 ) {
          totalCount
          edges {
            node {
              id
              frontmatter{
                title
                subtitle
                date(formatString: "YYYY")
                type
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `
  )

  return (
    <LatestPostsSection>
      <BlogAsideSectionLabel>Latest Posts</BlogAsideSectionLabel>
      {allMarkdownRemark.edges.map(({ node }) => (  
        <PostUnit>
          <PostUnitTitle to={node.fields.slug}>{node.frontmatter.title}</PostUnitTitle>
          <PostUnitSubtitle>{node.frontmatter.subtitle}</PostUnitSubtitle>
        </PostUnit>
      ))}
    </LatestPostsSection>
  )
}

export { LatestPostsAside }